import { CalendarEvent } from 'owa-calendar-types';
import { action } from 'satcheljs';

export const navigateToNextInstance = action('TimePanelConflictsView_navigateToNextInstance');

export const navigateToPreviousInstance = action(
    'TimePanelConflictsView_navigateToPreviousInstance'
);

export const setFutureInstances = action(
    'TimePanelConflictsView_setFutureInstances',
    (futureInstances: CalendarEvent[]) => ({ futureInstances })
);
